import { eachDayOfInterval } from 'date-fns';

export type CalendarDayViewModel = null | {
  date: Date;
  formatted: string;
  showMonth: boolean;
};

export const getCycleDays = (start: Date, end: Date) => {
  const weeks: CalendarDayViewModel[][] = [
    [null, null, null, null, null, null, null],
  ];

  const days = eachDayOfInterval({ start, end });

  let weekIndex = 0;
  let careCycleStartMarked = false;
  let needsMonthTransition = true;
  days.forEach(day => {
    const dayOfWeek = day.getDay();
    const dayOfMonth = day.getDate();

    if (dayOfMonth === 1) {
      needsMonthTransition = true;
    }

    if (dayOfWeek === 0 && !isEmpty(weeks[weekIndex])) {
      weekIndex++;
      weeks[weekIndex] = [];
    }

    let markMonth = false;

    if (!careCycleStartMarked || needsMonthTransition) {
      markMonth = true;
      needsMonthTransition = false;
      careCycleStartMarked = true;
    }

    let formattedMonth: number | string = day.getMonth() + 1;
    if (formattedMonth < 10) {
      formattedMonth = `0${formattedMonth}`;
    }

    let formattedDay: number | string = day.getDate();
    if (formattedDay < 10) {
      formattedDay = `0${formattedDay}`;
    }

    weeks[weekIndex][dayOfWeek] = {
      date: day,
      formatted: `${day.getFullYear()}-${formattedMonth}-${formattedDay}`,
      showMonth: markMonth,
    };
  });

  return weeks;
};

const isEmpty = (arr: unknown[]) => arr.length > 0 && !arr.some(x => !!x);
